// Locations
const LocationsList = () => import('@/views/locations/LocationsList.vue')
const LocationForm = () => import('@/views/locations/LocationForm.vue')
const LocationView = () => import('@/views/locations/LocationView.vue')

export const locationRoutes = [
  {
    path: '/locations',
    name: 'Locations',
    component: LocationsList,
    meta: {
      requireAuth: true,
      title: 'Locations'
    }
  },
  {
    path: '/locations/new',
    name: 'NewLocation',
    component: LocationForm,
    meta: {
      requireAuth: true,
      title: 'New Location'
    }
  },
  {
    path: '/locations/:id',
    name: 'ViewLocation',
    component: LocationView,
    meta: {
      requireAuth: true,
      title: 'View Location'
    }
  },
  {
    path: '/locations/:id/edit',
    name: 'EditLocation',
    component: LocationForm,
    meta: {
      requireAuth: true,
      title: 'Edit Location'
    }
  }
]
